import PropTypes from 'prop-types';
import React from 'react';
import 'intl';
import 'intl/locale-data/jsonp/en';
import url from 'url';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ru';
import reactTInit from '../../components/reactT/reactTInit';
import reactT from '../../components/reactT';
import Dropdown from 'react-bootstrap/Dropdown';
import CopyToClipboard from '../CopyToClipboard/CopyToClipboard';
import Bookmark from '../Bookmark/Bookmark';

const langcode = document.querySelector('html').getAttribute('lang');
moment.locale(langcode);
moment.updateLocale(langcode, {
  longDateFormat: {
      L: "DD/MM/YYYY",
  }
});

// Custom class for the result component
class FederatedResult extends React.Component {
  renderValue(field, doc) {
    const value = [].concat(doc[field] || null).filter((v) => v !== null);

    return value.join(", ");
  }

  dateFormat(date){
    if (typeof date !== undefined) {
      const prettyDate =  new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(Date.parse(date));
      const separator = "  ·  ";
      return separator + prettyDate;
    }
  }

  dateMomentFormat(date){
    if (typeof date !== undefined) {
      return moment(Date.parse(date)).format('DD MMMM YYYY');
    }
  }

  /**
   * Returns the appropriate link for a given search result.
   * 1. Use the canonical url if present.
   * 2. Next, attempt to find a url from the current host.
   * 3. Then, use the first url returned in the array of urls.
   * 4. Fall back to the legacy url field.
   * 5. Send an empty string if none of these options work.
   *
   * @param doc
   *   Search result object
   * @returns string
   */
  getCanonicalLink(doc) {
    const { hostname } = this.props;

    // 1. Use the canonical url as a first option
    if (Object.hasOwnProperty.call(doc, 'ss_canonical_url') && doc.ss_canonical_url) {
      return doc.ss_canonical_url;
    }

    // Use a url from the current host, if present.  Otherwise use the first Url.
    if (Object.hasOwnProperty.call(doc, 'sm_urls') && Array.isArray(doc.sm_urls)) {
      // Attempt to find a url from the current host.
      const currentHostUrl = doc.sm_urls.find((item) => {
        const myUrl = url.parse(item);
        return myUrl.hostname === hostname;
      });

      // 2. Use the url from the current host.
      if (currentHostUrl) {
        return currentHostUrl;
      }

      // 3. Use the first url.
      return doc.sm_urls[0];
    }

    // 4. Fall back to the single url (which will be relative)
    if (Object.hasOwnProperty.call(doc, 'ss_url') && doc.ss_url) {
      return doc.ss_url;
    }

    // 5. If no valid urls are passed, return nothing. This will result in an
    // unlinked title, but at least it won't crash.
    return '';
  }

  intersperse(arr, sep) {
    if (arr.length === 0) {
      return [];
    }

    return arr.slice(1).reduce(function(xs, x, i) {
      return xs.concat([sep, x]);
    }, [arr[0]]);
  }

  renderSitenameLinks(sitenames, urls, originalSitename) {
    if (sitenames !== null && urls !== null) {

      var sites = [];
      for (var i = 0; i < sitenames.length; i++) {
        sites.push(<a className="search-results__site-name" href={urls[i]} key={i}>{sitenames[i]}</a>);
        if (i !== (sitenames.length - 1)) {

        }
      }
      return this.intersperse(sites, " | ");
    }

    if (originalSitename !== null) {
      return originalSitename;
    }

    return null;
  }

  scrollToResult = () => {
    // Extract the value of the 'result' query parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const resultId = urlParams.get('result');

    if (resultId) {
      // Use the extracted result ID as the target ID
      const targetElement = document.getElementById(resultId);

      if (targetElement) {
        // Adjust this value to fine-tune the scrolling position
        const yOffset = -60;

        // Get the height of the admin toolbar (if it exists)
        const adminToolbar = document.getElementById('toolbar-bar');
        const adminToolbarHeight = adminToolbar ? adminToolbar.offsetHeight : 0;

        window.scrollTo({
          top: targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset - adminToolbarHeight,
          behavior: 'smooth',
        });
      }
    }
  };

  componentDidMount() {
    this.scrollToResult();
  }

  render() {
    reactTInit();
    const { doc, highlight } = this.props;

    let name = doc.ss_origin_title;

    let excerpt = '';

    let docUrl = this.getCanonicalLink(doc);
    let parsedUrl = new URL(docUrl);
    let relativePath = parsedUrl.pathname;
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('result');
    const currentPathWithQuery = currentUrl.pathname + currentUrl.search;

    // To update the pager to the current page.
    const queryParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(queryParams.get('page'), 10);

    if (!isNaN(currentPage) && (currentPage - 1) > this.props.start) {
      queryParams.set('page', 1);

      // Update the current URL without triggering a full page reload.
      const resultParam = queryParams.get('result');
      if (resultParam !== null) {
        queryParams.delete('result');
      }

      const newUrl = window.location.pathname + '?' + queryParams.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }

  if (highlight[Object.keys(highlight)[0]] !== undefined && highlight[Object.keys(highlight)[0]] !== null && highlight[Object.keys(highlight)[0]] !== '') {
    excerpt=
    <div className="search-excerpt">
    <div className="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item" dangerouslySetInnerHTML={{__html: highlight[Object.keys(highlight)[0]]}} />
    </div>;
  }

  let document_author = '';

  if (doc.ss_author !== undefined && doc.ss_author !== null && doc.ss_author !== '') {
    document_author =
    <li>
    <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Author')+': '}} ></span>
    {doc.ss_author}
    </li>;
  }

  let document_number = '';

  if (doc.ss_document_number !== undefined && doc.ss_document_number !== null && doc.ss_document_number !== '') {
    document_number =
    <li>
    <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Document number')+': '}} ></span>
    {doc.ss_document_number}
    </li>;
  }

    let publisher_name = '';

    if (doc.sm_document_source_name !== undefined && doc.sm_document_source_name !== null && doc.sm_document_source_name !== '') {
    publisher_name =
    <li>
      <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Document source')+': '}} ></span>
      {
        doc.sm_document_source_name.map((doc_source, i) => (
          <div key={i} className="field field--name-field-document-source">
            <a href={document.location.origin + (langcode === 'en' ? '' : '/' + langcode) + doc.sm_document_source_path[i]}>
              {doc_source}
            </a>
          </div>
        ))
      }
    </li>
    }

    // Parent (root convention) book link for unhcr_book results, mirroring the
    // "Book" line on the My Books teaser (book_top_level). UNHCRRW-2407.
    let parent_book = '';
    if (doc.ss_root_book_title !== undefined && doc.ss_root_book_title !== null && doc.ss_root_book_title !== ''
      && doc.ss_root_book_url !== undefined && doc.ss_root_book_url !== null && doc.ss_root_book_url !== '') {
      parent_book =
      <li>
        <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Book')+': '}} ></span>
        <span className="field field--name-book-top-level">
          <a href={doc.ss_root_book_url}>{doc.ss_root_book_title}</a>
        </span>
      </li>;
    }

    let doc_created = '';
    if (doc.ss_publication_date_string !== undefined && doc.ss_publication_date_string !== null) {
      doc_created =  
      <li>
      <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Date')+': '}} ></span>
      {doc.ss_publication_date_string}
      </li>;
    }

    let document_status = '';
    if (doc.ss_field_status  !== undefined && doc.ss_field_status !== null && doc.ss_field_status === 'intranet') {
      document_status =
      <div className="document-status-wrapper">
      <div className="document-status-icon mr-1"></div>
      <div className="field field--name-field-status field--type-list-string field--label-hidden field__item" dangerouslySetInnerHTML={{__html: reactT('Internal document')}}/>
      </div>
    }

    const randomSuffix = Math.floor(Math.random() * 1000);
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <button
        className="btn btn-outline-badge font-weight-normal d-flex btn-sm align-items-center btn-toggle-dark"
        type="button"
        id={children.toLowerCase()+'-dropdown-'+randomSuffix}
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        title={children}
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </button>
    ));

    let copyToClipboard = '';
    if (doc.ss_citation !== undefined && doc.ss_citation !== null && doc.ss_citation !== '') {

      copyToClipboard = <CopyToClipboard />;

    }


    let share = '';
    if (doc.ss_field_status !== undefined && doc.ss_field_status !== null && doc.ss_field_status === 'internet') {
    share =
<Dropdown className="field field-share" >
  <Dropdown.Toggle className="btn btn-outline-badge font-weight-normal d-flex btn-sm align-items-center btn-toggle-dark" as={CustomToggle}>
  {reactT('Share')}
  </Dropdown.Toggle>

  <Dropdown.Menu className='w-100'>
    <a className="facebook" href={"https://www.facebook.com/sharer/sharer.php?u="+document.location.origin + relativePath+"&t="+name} target="_blank" rel="noopener noreferrer">Facebook</a>
    <a className="linkedin" href={"https://www.linkedin.com/sharing/share-offsite/?url="+document.location.origin + relativePath} target="_blank" rel="noopener noreferrer">LinkedIn</a>
    <a className="twitter" href={"https://twitter.com/intent/tweet?text="+name+"&url="+document.location.origin + relativePath} target="_blank" rel="noopener noreferrer">X</a>
    <a className="email" href={"mailto:?subject="+name+"&body="+document.location.origin + relativePath}>Email</a>
  </Dropdown.Menu>
</Dropdown>
    }

    let citation = '';

    if (doc.ss_citation !== undefined && doc.ss_citation !== null && doc.ss_citation !== '') {
      citation =
      <Dropdown className="field field--name-field-citation dropdown position-static" >
        <Dropdown.Toggle className="btn btn-outline-badge font-weight-normal d-flex btn-sm align-items-center btn-toggle-dark" as={CustomToggle}>
        {reactT('Citation')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
        <div className="field__item">
          <div className="citation-text" dangerouslySetInnerHTML={{__html: doc.ss_citation +' [' + reactT('accessed ') + moment().format("DD MMMM YYYY") + ']'}}/>
          {copyToClipboard}
        </div>
        </Dropdown.Menu>
      </Dropdown>
    }
    let docID = doc.id.split('/').pop().split(':')[0];
    let download = '';

    if ((Array.isArray(doc.sm_external_doc_url) && doc.sm_external_doc_url.length > 0) ||
        (Array.isArray(doc.sm_internal_doc_url) && doc.sm_internal_doc_url.length > 0)) {

      let doc_url =
          (Array.isArray(doc.sm_external_doc_url) && doc.sm_external_doc_url.length > 0 && doc.ss_field_status === 'internet')
              ? `/${langcode}/download/${docID}`
              : (Array.isArray(doc.sm_internal_doc_url) && doc.sm_internal_doc_url.length > 0 && doc.ss_field_status === 'intranet')
                  ? `/${langcode}/download/${docID}`
                  : null;

      if (doc_url) {
        download = (
            <div className="field field--name-field-document field--type-entity-reference field--label-hidden field__item">
              <div className="field field--name-field-media-file field--type-file field--label-hidden field__item">
                <a
                    href={doc_url}
                    className="file-download file-download-application file-download-pdf btn btn-secondary btn-sm border border-secondary download-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    download=""
                    title={reactT('Download')}
                    dangerouslySetInnerHTML={{ __html: reactT('Download') }}
                />
              </div>
            </div>
        );
      }
    }

    let documentTranslations = '';
    if (doc.sm_document_translations !== undefined && doc.sm_document_translations !== null && Array.isArray(doc.sm_document_translations) && doc.sm_document_translations.length > 0) {
      const translationLinks = doc.sm_document_translations.map((translation, index) => {
        const [iso, label, translationUrl] = translation.split('|');
        return (
          <a key={index} href={translationUrl} title={label} className="translation-link">
            {iso.toUpperCase()}
          </a>
        );
      });

      documentTranslations = (
        <div className="document-translations small mt-2">
          <span className="field-label-inline" dangerouslySetInnerHTML={{__html: reactT('Languages available')+': '}} ></span>
          {this.intersperse(translationLinks, ' | ')}
        </div>
      );
    }

    let addToFavorite = '';

    /*global drupalSettings:true*/
    if(typeof drupalSettings !== "undefined" && drupalSettings['user']['uid'] > '0') {
      let currentUserID = drupalSettings['user']['uid'];
      let flaggingUsers = JSON.stringify(doc.itm_flag_favorite);
      let flagged = '';
      if (doc.itm_flag_favorite !== undefined && flaggingUsers.includes(currentUserID)) {
        flagged = true;
        }
        else {
          flagged = false;
        }

        addToFavorite = <Bookmark flagged={flagged} onClick={this.onChange} flagToken={doc.flag_token} unflagToken={doc.unflag_token} docID={docID} />
    }

    return (
    <div className="views-row">
      <div className="contextual-region search-result node node--type-document node--view-mode-search-result ds-1col clearfix" id={`result-${docID}-${langcode}`}>
         {document_status} 
         <div className="field--name-node-title">
        <h3 className="small-h3">
          <a href={`${relativePath}?prevDestination=search&prevPath=${currentPathWithQuery}&result=result-${docID}-${langcode}`} dangerouslySetInnerHTML={{__html: name}} />
        </h3>
        {addToFavorite}
     </div>
     {excerpt}
        <ul className="document-info mb-0">
          {document_author} {document_number} {publisher_name} {parent_book} {doc_created}
        </ul>
        {documentTranslations}
        <div className="document-actions d-flex align-items-center"> {citation} {share} {download} </div>
      </div>
    </div>
    );
  }
}

FederatedResult.propTypes = {
  doc: PropTypes.object,
  fields: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
    hostname: PropTypes.string,
};

export default FederatedResult;
